/** @jsx jsx */
import React from 'react'
import { jsx, Box, Flex, Grid } from 'theme-ui'

import Button from '../shared/Buttons/Button'
import { BgImg } from '../shared/BgImage'
import Img from 'gatsby-image'
import StyledHeading from '../shared/Typography/Heading/Heading'
import styled from '@emotion/styled'
import Link from '../shared/Typography/Link/Link'

const ContentContainer = styled.div`
  z-index: 10;
`

const CtaGrid = props => {
  const quadLayout = props.layoutVariation === 'quadRow'
  const imageOnly = props.layoutVariation === 'imageOnly'
  const tall = props.layoutVariation === 'tall'

  const gridStyles = quadLayout
    ? {
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        width: '100%',
        position: 'absolute',
      }
    : {}
  return (
    <Grid
      gap={['1em', '1em', '1em', '1em']}
      columns={quadLayout ? [2, 2, 4, 4, 4] : [1, 1, 1, 2, 2]}
      sx={
        quadLayout
          ? {
              'div > img': {
                gridArea: '1 / 1 / 2 / 2',
              },
              gridTemplateColumns: 'repeat(auto-fill)',
            }
          : {}
      }
    >
      {props.gridItems.map((i, k) => (
        <Link
          key={k}
          to={i.actionButton && i.actionButton.toSlug}
          sx={
            quadLayout && {
              position: 'relative',
              '::before': {
                content: "''",
                paddingBottom: '100%',
                display: 'block',
              },
            }
          }
        >
          <Flex
            flex={1}
            sx={{
              minHeight: tall
                ? '70vh'
                : quadLayout
                ? ['auto']
                : ['195px', '250px', '250px', '250px', '400px'],
              textAlign: 'left',
              justifyContent: 'flex-start',
              position: 'relative',
              alignItems: 'flex-end',
              textDecoration: 'none ',
              ...gridStyles,
            }}
          >
            {!quadLayout && !imageOnly && (
              <ContentContainer
                sx={{
                  p: ['0px 20px 30px 20px', null, null, 32],
                  borderImageWidth: 0,
                }}
              >
                <Box sx={{ width: '100%' }}>
                  <StyledHeading
                    sx={{
                      color: i.textColor || 'background',
                      textTransform: 'uppercase',
                    }}
                    as="h3"
                    variant="semiBold"
                  >
                    {i.title}
                  </StyledHeading>
                  {i.actionButton && (
                    <Button
                      sx={{
                        textTransform: 'uppercase',
                        mt: '5px',
                        minWidth:
                          !i.actionButton.buttonStyle.includes('Link') && 195,
                      }}
                      variant={i.actionButton.buttonStyle}
                      size={i.actionButton.buttonSize || 'medium'}
                    >
                      {i.actionButton.buttonLabel}
                    </Button>
                  )}
                </Box>
              </ContentContainer>
            )}

            {i.image.fluid ? (
              <BgImg
                imgStyle={{ objectFit: imageOnly ? 'contain' : 'cover' }}
                fluid={i.image.fluid}
                backgroundColor={'#eeeeee'}
              />
            ) : (
              <img src={i.image.file.url} alt={i.image.title} />
            )}
          </Flex>
          {quadLayout && (
            <Box
              sx={{
                width: ['100%'],
                py: [10, 10, 10, 10, 10],
                position: 'absolute',
                bottom: 0,
                textAlign: 'center',
                bg: 'lighterGray',
              }}
            >
              <StyledHeading
                sx={{
                  textTransform: 'uppercase',
                  fontSize: [2, 2, 2, 2, 3],
                }}
                as="h5"
                variant="semiBold"
              >
                {i.title}
              </StyledHeading>
            </Box>
          )}
        </Link>
      ))}
    </Grid>
  )
}

export default CtaGrid
